import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {v4 as uuidv4} from 'uuid';

import {RootState} from '../../app/rootReducer';
import {Condition} from '../../types/forms';

export interface Section {
  id: string;
  title: string;
  description: string;
  isMultiResponse?: boolean;
  dependency: boolean;
  conditions: Condition[];
  listQuestions: any[];
  // Marca la sección especial de toma de pedido (formulario de venta). Quien
  // renderice la UI de toma de pedido usa este flag como discriminador.
  isSalesSection?: boolean;
  // Etiquetas de producto que se muestran en la toma de pedido; vacío = todo el
  // catálogo del proyecto. El filtro lo aplica el commerce-api.
  salesTags?: string[];
}

export interface SectionState {
  data: Section[];
  error: string | null;
  isLoading: boolean;
}

const initialState = {
  data: [
    {
      id: uuidv4(),
      title: 'Nueva sección',
      description: 'Descripción de sección',
      isMultiResponse: false,
      dependency: false,
      conditions: [],
      listQuestions: [],
    },
  ],
  error: null,
  isLoading: false,
} as SectionState;

const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {
    getSection(state, action: PayloadAction<Section[]>) {
      state.data = action.payload;
    },
    addSection(state, action: PayloadAction<Section>) {
      // La sección de venta ('Toma de pedido') siempre queda al final: las nuevas
      // secciones se insertan antes de ella.
      const salesIndex = state.data.findIndex(
        section => section.isSalesSection,
      );
      if (salesIndex === -1) {
        state.data.push(action.payload);
      } else {
        state.data.splice(salesIndex, 0, action.payload);
      }
    },
    updateSection(state, action: PayloadAction<Section>) {
      const index = state.data.findIndex(
        section => section.id === action.payload.id,
      );
      state.data[index] = {
        ...state.data[index],
        ...action.payload,
      };
    },
    disableSection(state, action: PayloadAction<Section>) {
      const index = state.data.findIndex(
        section => section.id === action.payload.id,
      );
      // La sección de venta no se puede eliminar.
      if (index === -1 || state.data[index].isSalesSection) return;
      state.data.splice(index, 1);
    },
  },
});

export const getSectionSelector = (state: RootState) => state.section.data;
export const isSectionLoading = state => state.section.isLoading;
export const getErrorSelector = state => state.section.error;

export default sectionSlice.reducer;
export const {getSection, addSection, updateSection, disableSection} =
  sectionSlice.actions;
